$(document).on('turbo:load turbo:render', () => {

    if($(".compensation-multi-select").prop("checked") == true){
        disableFields();
    }

    $(".compensation-multi-select").on("click", (e) =>{
        let $el = $(e.currentTarget);
        //@ts-ignore
       if (e.currentTarget.checked){
            disableFields();
       }
       else {
           enableFields();
       }
    })

});


function disableFields() {
    $(".multi-select-text").each((index, el)=>{
        let $el = $(el);
        $(el).val("0.00");
        $(el).trigger("change");
        $el.prop("disabled", true);


    });
    $(".multi-select-radio").each((index, el)=>{
        let $el = $(el);
        //@ts-ignore
        $el.trigger("click");
    });
    $(".multi-select-disable").each((index, el) =>{
        let $el = $(el);
        $el.prop("disabled", true);
    });

    $(".total-contribution").html("$0.00")
}

function enableFields() {
    $(".multi-select-text").each((index, el) => {
        let $el = $(el);
        $el.prop("disabled", false);
        $el.val("");


    });
    $(".multi-select-radio").each((index, el) => {
        let $el = $(el);
        $el.prop("checked", false);
    });
    $(".multi-select-disable").each((index, el) =>{
        let $el = $(el);
        $el.prop("disabled", false);
    });

}